import APay from "@pages/profile-v2/pages/deposit/paymentMethods/apay";
import BetterBro from "@pages/profile-v2/pages/deposit/paymentMethods/betterPro";
import Monetix from "@pages/profile-v2/pages/deposit/paymentMethods/monetix.js";
import Piastrix from "@pages/profile-v2/pages/deposit/paymentMethods/piastrix";
import Skrill from "@pages/profile-v2/pages/deposit/paymentMethods/skrill";
import STP from "@pages/profile-v2/pages/deposit/paymentMethods/stp";
import Unlimit from "@pages/profile-v2/pages/deposit/paymentMethods/unlimit";
import Vcreditos from "@pages/profile-v2/pages/deposit/paymentMethods/vcreditos";
import VevopayPopyPara from "@pages/profile-v2/pages/deposit/paymentMethods/vevopayPopyPara";
import Vpag from "@pages/profile-v2/pages/deposit/paymentMethods/vpag";
import * as paymentLogos from "../../assets/paymentLogos/onwhite";
import AnindaCreditCard from "./paymentMethods/anindaCreditCard.js";
import AnindaMFT from "./paymentMethods/anindaMFT.js";
import BankTransfer from "./paymentMethods/bankTransfer.js";
import BankTransferCepbank from "./paymentMethods/bankTransferCepbank.js";
import CoinsPaid from "./paymentMethods/coinspaid.js";
import Crypto from "./paymentMethods/crypto.js";
import CryptoPayment from "./paymentMethods/cryptopayment.js";
import DeltaPay from "./paymentMethods/deltapay.js";
import Fixturka from "./paymentMethods/fixturka.js";
import FxCuzdan from "./paymentMethods/fxcuzdan.js";
import GuvenilirQR from "./paymentMethods/guvenilirqr.js";
import IxirPay from "./paymentMethods/ixirpay.js";
import Mefete from "./paymentMethods/mefete.js";
import MiniHavale from "./paymentMethods/miniHavale.js";
import MovenPay from "./paymentMethods/movenpay.js";
import Nuvei from "./paymentMethods/nuvei.js";
import Odebitir from "./paymentMethods/odebitir.js";
import Odendibil from "./paymentMethods/odendibil.js";
import Papara from "./paymentMethods/papara.js";
import PaparaFast from "./paymentMethods/paparaFast.js";
import Paparazzi from "./paymentMethods/paparazzi.js";
import Payco from "./paymentMethods/payco.js";
import Penapay from "./paymentMethods/penapay.js";
import PromotionalCode from "./paymentMethods/promotionalCode.js";
import SapphirePapara from "./paymentMethods/sapphirepapara.js";
import Thorpay from "./paymentMethods/thorpay.js";
import TrendCard from "./paymentMethods/trendCard.js";
import TrendHavale from "./paymentMethods/trendHavale.js";
import TurboHavale from "./paymentMethods/turboHavale.js";
import TurboYatirim from "./paymentMethods/turboYatirim.js";
import UnifyPay from "./paymentMethods/unifyPay.js";
import Vevopay from "./paymentMethods/vevopay.js";

export default function getDepositItems({ props }) {
	const {
		getBankList,
		getOdendibilBankList,
		languages,
		translate,
		getFilteredDepositBonuses,
		userCurrency,
		currentLanguage,
		convertionRates,
	} = props;
	const selectedLanguage = languages.find((item) => item.active);
	return (
		[
			{
				logo: paymentLogos["DeltaPay"],
				name: "DeltaPayDeposit",
				id: "DeltaPayDeposit",
				logoName: "Delta Pay",
				bonusList: [],
				bonusId: "",
				userCurrency,
				convertionRates,
				bonusDescription: "",
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: DeltaPay,
				languages: languages,
				externalFunc: {
					makeDeposit: props.depositDeltapay,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["CoinsPaid"],
				name: "COINSPAID",
				id: "CoinsPaid",
				logoName: "COINS PAID",
				bonusList: [],
				bonusId: "",
				userCurrency,
				convertionRates,
				bonusDescription: "",
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: CoinsPaid,
				languages: languages,
				externalFunc: {
					makeDeposit: props.depositCoinsPaid,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["hizliQr"],
				name: "GUVENILIRQR",
				id: "GuvenilirQR",
				logoName: "GUVENILIR QR",
				bonusList: [],
				bonusId: "",
				convertionRates,
				userCurrency,
				bonusDescription: "",
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: GuvenilirQR,
				languages: languages,
				externalFunc: {
					makeDeposit: props.depositGuvenilirQR,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			...[
				"MonetixEcuadorCashTransfer",
				"MonetixEcuadorBankTransfer",
				"MonetixCostaRicaBankTransfer",
				"MonetixElSalvadorCashTransfer",
				"MonetixChileCashTransfer",
				"MonetixWebpayChile",
				"MonetixChileBankTransfer",
				"MonetixApplePayUK",
				"MonetixOpenBankingEU",
				"MonetixArgentinaBankTransfer",
				"MonetixPagoEfectivo",
				"MonetixPeruBankTransfer",
				"MonetixNequi",
				"MonetixPeruCashTransfer",
				"MonetixPSE",
				"MonetixColumbiaBankTransfer",
				"MonetixEfecty",
				"MonetixCrypto",
				"MonetixCard",
				"MonetixPix",
				"MonetixOxxo",
				"MonetixBoleto",
				"MonetixBinancePay",
				"MonetixMexicoBankTransfer",
				"MonetixSpei",
				"MonetixPicPay",
				"MonetixCostaRicaCash",
				"MonetixBrazilCard",
				"MonetixBoliviaBankTransfer",
				"MonetixDeunaQR",
				"MonetixCoDi",
				"MonetixPanamaCash",
				"MonetixYape",
				"MonetixVenezuelaBankTransfer",
				"MonetixPagamigos",
				// "MonetixPromptpay",
				// "MonetixThailandBank",
				// "MonetixRussiaP2PTransfer",
				// "MonetixRussiaP2PTransferByCard",
				// "MonetixRussiaP2PTransferByPhone",
				// "MonetixRussiaP2PTransferBySber",
				// "MonetixRussiaP2PTransferByTbank",
				// "MonetixRussiaP2PTransferByAbroadPhone",
				// "MonetixRussiaP2PTransferByAbroadCard",
				// "MonetixTrueMoneyWallet",
			].map((x) => {
				const name = x.replace("Monetix", "MONETIX ");
				return {
					logo: paymentLogos[x],
					name: name.toUpperCase(),
					id: x,
					bonusList: [],
					bonusId: "",
					userCurrency,
					convertionRates,
					bonusDescription: "",
					feature: translate("FREE_INSTANT"),
					type: "external",
					currencies: [],
					logoCls: x === "MonetixApplePayUK" ? "w-60" : "no-filter",
					component: Monetix,
					languages: languages,
					externalFunc: {
						method: x.replace("Monetix", ""),
						makeDeposit: props.depositMonetix,
						getFilteredBonuses: getFilteredDepositBonuses,
					},
				};
			}),
			{
				logo: paymentLogos["trendKK"],
				name: "TRENDCARD",
				id: "TrendHavaleCard",
				logoName: "TrendCard",
				bonusList: [],
				bonusId: "",
				userCurrency,
				convertionRates,
				bonusDescription: "",
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: TrendCard,
				languages: languages,
				externalFunc: {
					makeDeposit: props.depositTrend,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["trend"],
				name: "TRENDHAVALE",
				id: "TrendHavale",
				logoName: "TrendHavale",
				bonusList: [],
				bonusId: "",
				userCurrency,
				convertionRates,
				bonusDescription: "",
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: TrendHavale,
				languages: languages,
				externalFunc: {
					makeDeposit: props.depositTrend,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["odebitir"],
				name: "ODEBITIR",
				id: "Odebitir",
				logoName: "7/24 HAVALE",
				bonusList: [],
				bonusId: "",
				userCurrency,
				convertionRates,
				bonusDescription: "",
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: Odebitir,
				languages: languages,
				externalFunc: {
					makeDeposit: props.depositOdebitir,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: currentLanguage === "tr" ? paymentLogos["pcodeTr"] : paymentLogos["pcodeEn"],
				name: "PROMOTIONALCODE",
				id: "PromotionalCode",
				logoName: translate("PROMOTIONAL_CODE"),
				bonusList: [],
				bonusId: "",
				userCurrency,
				convertionRates,
				bonusDescription: "",
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: PromotionalCode,
				languages: languages,
				externalFunc: {
					makeDeposit: props.depositPromotional,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["turbohavale"],
				name: "TURBOHAVALE",
				id: "TurboHavale",
				logoName: "TURBO HAVALE",
				bonusList: [],
				bonusId: "",
				userCurrency,
				convertionRates,
				bonusDescription: "",
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: TurboHavale,
				languages: languages,
				externalFunc: {
					makeDeposit: props.depositTurboHavale,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["fxcuzdan"],
				name: "FXCUZDAN",
				id: "FxCuzdan",
				logoName: "FXCUZDAN",
				bonusList: [],
				bonusId: "",
				userCurrency,
				convertionRates,
				bonusDescription: "",
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: FxCuzdan,
				languages: languages,
				externalFunc: {
					makeDeposit: props.depositFXcuzdan,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["sapphirepapara"],
				name: "SAPPHIREPAPARA",
				id: "SapphirePapara",
				logoName: "SAFIR PAPARA",
				bonusList: [],
				bonusId: "",
				userCurrency,
				convertionRates,
				bonusDescription: "",
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: SapphirePapara,
				languages: languages,
				externalFunc: {
					makeDeposit: props.depositSapphirePapara,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},

			{
				logo: paymentLogos["paybol"],
				name: "TURBOYATIRIM",
				id: "TurboYatirim",
				logoName: "TURBO YATIRIM",
				bonusList: [],
				bonusId: "",
				userCurrency,
				convertionRates,
				bonusDescription: "",
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: TurboYatirim,
				languages: languages,
				externalFunc: {
					makeDeposit: props.depositTurboYatirim,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["vevopay"],
				name: "VEVOPAY",
				id: "Vevopay",
				logoName: "VEVOPAY",
				bonusList: [],
				bonusId: "",
				userCurrency,
				convertionRates,
				bonusDescription: "",
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: Vevopay,
				languages: languages,
				externalFunc: {
					makeDeposit: props.depositVevopay,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["vevopayPopyPara"],
				name: "VEVOPAY",
				id: "VevopayPopy",
				logoName: "VevopayPopyPara",
				bonusList: [],
				bonusId: "",
				userCurrency,
				convertionRates,
				bonusDescription: "",
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: VevopayPopyPara,
				languages: languages,
				externalFunc: {
					makeDeposit: props.depositVevopay,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["payco"],
				name: "PAYCO",
				id: "Payco",
				logoName: "PAYCO",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: Payco,
				languages: languages,
				externalFunc: {
					depositFixturka: props.depositPayco,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["payfix"],
				name: "FIXTURKA",
				id: "Fixturka",
				logoName: "PAYFIX",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: Fixturka,
				languages: languages,
				externalFunc: {
					depositFixturka: props.depositFixturka,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["mft"],
				name: "MFT",
				id: "MFT",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				description:
					"MEFETE yöntemi ile dilediğiniz saatte EFT yaparak hesabınıza yatırım yapabilirsiniz.",
				currencies: [],
				component: Mefete,
				languages: languages,
				externalFunc: {
					depositMFT: props.depositMFT,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["penapay"],
				name: "PENAPAY",
				id: "Penapay",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "internal",
				component: Penapay,
				currencies: [],
				languages: languages,
				externalFunc: {
					depositPenapay: props.depositPenapay,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: currentLanguage ? paymentLogos["kkTr"] : paymentLogos["kkEn"],
				name: "THORPAY",
				id: "SAMR",
				logoName: selectedLanguage.code === "en" ? "CREDIT CARD" : "KREDI KARTI",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "internal",
				currencies: [],
				component: Thorpay,
				languages: languages,
				externalFunc: {
					getFilteredBonuses: getFilteredDepositBonuses,
					newCustomer: props.newCustomer,
					depositThorpay: props.depositThorpay,
					smsStatus: props.smsStatus,
					getSms: props.getSms,
					paymentStatus: props.paymentStatus,
				},
			},
			{
				logo: paymentLogos["cryptopay"],
				name: "CRYPTOPAY",
				id: "CryptoPay",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				description: "You can pay with cryptocurrencies",
				currencies: [],
				cryptocurrency: "BTC",
				languages: languages,
				component: Crypto,
				externalFunc: {
					depositCrypto: props.depositCrypto,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["ixirpay"],
				name: "IXIRPAY",
				id: "IxirPay",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: IxirPay,
				languages: languages,
				externalFunc: {
					getBankList: getBankList,
					depositIxirpay: props.depositIxirpay,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["cepbank"],
				name: "ODENDIBIL-CEPBANK",
				logoName: "CEPBANK",
				id: "Odendibil-cepbank",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: Odendibil,
				paymentMethod: "cepbank",
				languages: languages,
				externalFunc: {
					getBankList: getOdendibilBankList,
					depositCepbankQr: props.depositOdendibilCepbankQR,
					depositPep: props.depositOdendibilPep,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["qr"],
				name: "ODENDIBIL-QR",
				logoName: "QR",
				id: "Odendibil-qr",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: Odendibil,
				paymentMethod: "qr",
				languages: languages,
				externalFunc: {
					getBankList: getOdendibilBankList,
					depositCepbankQr: props.depositOdendibilCepbankQR,
					depositPep: props.depositOdendibilPep,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["pep"],
				name: "ODENDIBIL-PEP",
				logoName: "PEP",
				id: "Odendibil-pep",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: Odendibil,
				paymentMethod: "pep",
				languages: languages,
				externalFunc: {
					getBankList: getOdendibilBankList,
					depositCepbankQr: props.depositOdendibilCepbankQR,
					depositPep: props.depositOdendibilPep,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["cryEth"],
				name:
					window.TENANT === "chokwin"
						? "ETH CHOKWIN CRYPTOPAYMENT"
						: window.TENANT === "mars"
							? "ETH MARS CRYPTOPAYMENT"
							: window.TENANT === "luckykingbet"
								? "ETH LUCKY KING BET CRYPTOPAYMENT"
								: window.TENANT === "gannar"
									? "ETH GANNAR CRYPTOPAYMENT"
									: "ETH ZENGİNSİN CRYPTOPAYMENT",
				id: "EtoroCryptopayment-ETH",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				logoCls: window.IS_MARS ? "no-filter" : "",
				component: CryptoPayment,
				cryptoCurrency: "ETH",
				languages: languages,
				externalFunc: {
					depositCryptoPayment: props.depositCryptoPayment,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["cryBtc"],
				name:
					window.TENANT === "chokwin"
						? "BTC CHOKWIN CRYPTOPAYMENT"
						: window.TENANT === "mars"
							? "BTC MARS CRYPTOPAYMENT"
							: window.TENANT === "luckykingbet"
								? "BTC LUCKY KING BET CRYPTOPAYMENT"
								: window.TENANT === "gannar"
									? "BTC GANNAR CRYPTOPAYMENT"
									: "BTC ZENGİNSİN CRYPTOPAYMENT",
				id: "EtoroCryptopayment-BTC",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: CryptoPayment,
				logoCls: window.IS_MARS ? "no-filter" : "",
				cryptoCurrency: "BTC",
				languages: languages,
				externalFunc: {
					depositCryptoPayment: props.depositCryptoPayment,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["cryTron"],
				name:
					window.TENANT === "chokwin"
						? "TRX CHOKWIN CRYPTOPAYMENT"
						: window.TENANT === "mars"
							? "TRX MARS CRYPTOPAYMENT"
							: window.TENANT === "luckykingbet"
								? "TRX LUCKY KING BET CRYPTOPAYMENT"
								: window.TENANT === "gannar"
									? "TRX GANNAR CRYPTOPAYMENT"
									: "TRX ZENGİNSİN CRYPTOPAYMENT",
				id: "EtoroCryptopayment-TRX",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: CryptoPayment,
				logoCls: window.IS_MARS ? "no-filter" : "",
				cryptoCurrency: "TRX",
				languages: languages,
				externalFunc: {
					depositCryptoPayment: props.depositCryptoPayment,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["cryUsdt"],
				name:
					window.TENANT === "chokwin"
						? "USDT(TRC20) CHOKWIN CRYPTOPAYMENT"
						: window.TENANT === "mars"
							? "USDT(TRC20) MARS CRYPTOPAYMENT"
							: window.TENANT === "luckykingbet"
								? "USDT(TRC20) LUCKY KING BET CRYPTOPAYMENT"
								: window.TENANT === "gannar"
									? "USDT(TRC20) GANNAR CRYPTOPAYMENT"
									: "USDT(TRC20) ZENGİNSİN CRYPTOPAYMENT",
				id: "EtoroCryptopayment-USDT",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: CryptoPayment,
				logoCls: window.IS_MARS ? "no-filter" : "",
				cryptoCurrency: "USDT.TRC20",
				languages: languages,
				externalFunc: {
					depositCryptoPayment: props.depositCryptoPayment,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["MarsCryptopaymentETH"],
				name: "ETH MARS CRYPTOPAYMENT",
				id: "MarsCryptopaymentETH",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: CryptoPayment,
				cryptoCurrency: "ETH",
				languages: languages,
				externalFunc: {
					depositCryptoPayment: props.depositCryptoPayment,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["MarsCryptopaymentBTC"],
				name: "BTC MARS CRYPTOPAYMENT",
				id: "MarsCryptopaymentBTC",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: CryptoPayment,
				cryptoCurrency: "BTC",
				languages: languages,
				externalFunc: {
					depositCryptoPayment: props.depositCryptoPayment,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["MarsCryptopaymentTRON"],
				name: "TRX MARS CRYPTOPAYMENT",
				id: "MarsCryptopaymentTRON",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: CryptoPayment,
				cryptoCurrency: "TRX",
				languages: languages,
				externalFunc: {
					depositCryptoPayment: props.depositCryptoPayment,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["MarsCryptopaymentUSDT"],
				name: "USDT(TRC20) MARS CRYPTOPAYMENT",
				id: "MarsCryptopaymentUSDT",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: CryptoPayment,
				cryptoCurrency: "USDT.TRC20",
				languages: languages,
				externalFunc: {
					depositCryptoPayment: props.depositCryptoPayment,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["minihavale"],
				name: "MINIHAVALE",
				id: "Minihavale",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: MiniHavale,
				languages: languages,
				externalFunc: {
					depositMinihavale: props.depositMiniHavale,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["paparazzi"],
				name: "PAPARAZZI",
				id: "Paparazzi",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: Paparazzi,
				languages: languages,
				externalFunc: {
					depositPaparazzi: props.depositPaparazzi,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["banktransfer"],
				name: "BANKTRANSFER",
				logoName: selectedLanguage.code === "en" ? "BANK TRANSFER" : "BANKA TRANSFERI",
				id: "BankTransfer",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: BankTransfer,
				languages: languages,
				externalFunc: {
					depositBankTransfer: props.depositBankTransfer,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["cepbank"],
				name: "BANKTRANSFERCEPBANK",
				logoName: "BANKTRANSFER CEPBANK",
				id: "BankTransferCepbank",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: BankTransferCepbank,
				languages: languages,
				externalFunc: {
					depositBankTransfer: props.depositBankTransferCepbank,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				whiteLogo:
					currentLanguage === "tr"
						? paymentLogos["paparafastTr"]
						: paymentLogos["paparafastEn"],
				name: "PAPARA",
				logoName:
					selectedLanguage.code === "en" ? "DEPOSIT WITH SUPPORT" : "DESTEKLI YATIRIM",
				id: "Papara",
				bonusList: [],
				bonusId: "",
				order: 20,
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: Papara,
				languages: languages,
			},
			{
				whiteLogo:
					currentLanguage === "tr"
						? paymentLogos["kkhizliTr"]
						: paymentLogos["kkhizliEn"],
				name: "MOVENPAY-CREDITCARD",
				logoName:
					selectedLanguage.code === "en" ? "CREDIT CARD - FAST" : "KREDI KARTI - HIZLI",
				id: "MovenPay-CreditCard",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: MovenPay,
				languages: languages,
				externalFunc: {
					depositMovenPay: props.depositMovenPay,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["movenpayPapara"],
				name: "MOVENPAY-PAPARA",
				logoName: "PAPARA",
				id: "MovenPay-Papara",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: MovenPay,
				languages: languages,
				externalFunc: {
					depositMovenPay: props.depositMovenPayPapara,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: currentLanguage ? paymentLogos["paparafastTr"] : paymentLogos["paparafastEn"],
				name: "HIZLIPAPARA",
				logoName: selectedLanguage.code === "en" ? "PAPARA - FAST" : "PAPARA - HIZLI",
				id: "HizliPapara",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: PaparaFast,
				languages: languages,
				externalFunc: {
					depositPaparaFast: props.depositPaparaFast,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["anindamft"],
				name: "ANINDA PARATİM",
				id: "AnindaMFT",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: AnindaMFT,
				languages: languages,
				externalFunc: {
					depositAnindaMFT: props.depositAnindaMFT,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["anindacreditcard"],
				name: "ANINDA KREDİ KARTI",
				id: "AnindaIntegrationCreditCard",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: ["TRY"],
				component: AnindaCreditCard,
				languages: languages,
				externalFunc: {
					depositAnindaCreditCard: props.depositAnindaCreditCard,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["Piastrix"],
				name: "PIASTRIX",
				id: "Piastrix",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: Piastrix,
				languages: languages,
				externalFunc: {
					makeDeposit: props.depositPiastrix,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
			{
				logo: paymentLogos["STP"],
				name: "STP",
				id: "STP",
				bonusList: [],
				bonusId: "",
				bonusDescription: "",
				convertionRates,
				feature: translate("FREE_INSTANT"),
				type: "external",
				currencies: [],
				component: STP,
				languages: languages,
				externalFunc: {
					makeDeposit: props.depositSTP,
					getFilteredBonuses: getFilteredDepositBonuses,
				},
			},
		]
			.concat(
				[
					"SkrillDigitalWallet",
					"SkrillNeteller",
					"SkrillPaysafecard",
					"SkrillPaysafecash",
					"SkrillPagoEfectivo",
					"SkrillCreditCard",
					"SkrillBlik",
					"SkrillRapidTransfer",
					"SkrillGiropay",
					"SkrillDirectDebit",
					"SkrillSofort",
					"SkrillIdeal",
					"SkrillPoli",
					"SkrillPrzelewy24",
					"SkrillEPay",
					"SkrillTrustly",
					"SkrillAlipay",
					"SkrillAstroPayOnline",
					"SkrillAstroPayOffline",
					"SkrillAstroPayCash",
					"SkrillRapyd",
					"SkrillCash",
					"SkrillOnlineBank",
					"SkrillPix",
					"SkrillMach",
					"SkrillBoleto",
					"SkrillMbWay",
					"SkrillMultibanco",
				].map((x) => {
					const name = x.replace("Skrill", "Skrill ");
					return {
						logo: paymentLogos[x],
						name: name.toUpperCase(),
						id: x,
						bonusList: [],
						bonusId: "",
						bonusDescription: "",
						convertionRates,
						feature: translate("FREE_INSTANT"),
						type: "external",
						currencies: [],
						component: Skrill,
						languages: languages,
						externalFunc: {
							method: x.replace("Skrill", ""),
							makeDeposit: props.depositSkrill,
							getFilteredBonuses: getFilteredDepositBonuses,
						},
					};
				})
			)
			.concat(
				["APayDeposit", "APaySPEI"].map((x) => {
					const name = x.replace("APay", "APay ");
					return {
						logo: paymentLogos[x],
						name: name.toUpperCase(),
						id: x,
						bonusList: [],
						bonusId: "",
						bonusDescription: "",
						convertionRates,
						feature: translate("FREE_INSTANT"),
						type: "external",
						currencies: [],
						component: APay,
						languages: languages,
						externalFunc: {
							method: x.replace("APay", ""),
							makeDeposit: props.depositApay,
							getFilteredBonuses: getFilteredDepositBonuses,
						},
					};
				})
			)
			.concat(
				[
					"BetterBroPix",
					"BetterBroSPEI",
					"BetterBroPicPay",
					"BetterBroOpenBanking",
					"BetterBroOXXO",
					"BetterBroChileBankTransfer",
					"BetterBroVenezuelaPagoMovilHPP",
					"BetterBroChileKhipuHPP",
					"BetterBroChileMachHPP",
					"BetterBroChileBancoEstadoBankTransfer",
					"BetterBroChileBancoSantanderBankTransfer",
					"BetterBroChileBancodeChileBankTransfer",
					"BetterBroChileWebPay",
					"BetterBroArgentinaTransferencia",
					"BetterBroArgentinaMercadoPago",
					"BetterBroArgentinaNaranjaX",
					"BetterBroArgentinaMODO",
					"BetterBroArgentinaBNA",
				].map((x) => {
					let name = x.replace("BetterBro", "BetterBro ");
					if (
						[
							"BetterBroChileBankTransfer",
							"BetterBroVenezuelaPagoMovilHPP",
							"BetterBroChileKhipuHPP",
							"BetterBroChileMachHPP",
							"BetterBroChileBancoEstadoBankTransfer",
							"BetterBroChileBancoSantanderBankTransfer",
							"BetterBroChileBancodeChileBankTransfer",
							"BetterBroChileWebPay",
							"BetterBroArgentinaTransferencia",
							"BetterBroArgentinaMercadoPago",
							"BetterBroArgentinaNaranjaX",
							"BetterBroArgentinaMODO",
							"BetterBroArgentinaBNA",
						].includes(x)
					) {
						name = x.replace(/BetterBro([A-Z][a-z]+)([A-Z].+)/, "BetterBro $1 $2");
					}
					return {
						logo: paymentLogos[x],
						name: name === "OpenBanking" ? "SEPA Instant" : name.toUpperCase(),
						id: x,
						bonusList: [],
						bonusId: "",
						bonusDescription: "",
						feature:
							window.TENANT === "mars-pt" && currentLanguage === "pt"
								? "2 a 3 dias"
								: translate("FREE_INSTANT"),
						type: "external",
						currencies: [],
						logoCls:
							x === "BetterBroOXXO" ||
							x === "BetterBroChileBankTransfer" ||
							x === "BetterBroVenezuelaPagoMovilHPP" ||
							x === "BetterBroChileKhipuHPP" ||
							x === "BetterBroChileMachHPP" ||
							x === "BetterBroChileBancoEstadoBankTransfer" ||
							x === "BetterBroChileBancoSantanderBankTransfer" ||
							x === "BetterBroChileBancodeChileBankTransfer" ||
							x === "BetterBroChileWebPay" ||
							x === "BetterBroArgentinaTransferencia" ||
							x === "BetterBroArgentinaMercadoPago" ||
							x === "BetterBroArgentinaNaranjaX" ||
							x === "BetterBroArgentinaMODO" ||
							x === "BetterBroArgentinaBNA"
								? "no-filter"
								: "",
						component: BetterBro,
						languages: languages,
						externalFunc: {
							method: x.replace("BetterBro", ""),
							makeDeposit: props.depositBetterBro,
							getFilteredBonuses: getFilteredDepositBonuses,
						},
					};
				})
			)
			.concat(
				["Vcreditos"].map((x) => {
					const name = x.replace("Vcreditos", "Vcreditos ");
					return {
						logo: paymentLogos[x],
						name: name.toUpperCase(),
						id: x,
						bonusList: [],
						bonusId: "",
						bonusDescription: "",
						convertionRates,
						feature: translate("FREE_INSTANT"),
						type: "external",
						currencies: [],
						component: Vcreditos,
						languages: languages,
						externalFunc: {
							method: x.replace("Vpag", "").toLowerCase(),
							makeDeposit: props.depositVcreditos,
							getFilteredBonuses: getFilteredDepositBonuses,
						},
					};
				})
			)
			.concat(
				["VpagWallet", "VpagFlash"].map((x) => {
					const name = x.replace("Vpag", "Vpag ");
					return {
						logo: paymentLogos[x],
						name: name.toUpperCase(),
						id: x,
						bonusList: [],
						bonusId: "",
						bonusDescription: "",
						convertionRates,
						feature: translate("FREE_INSTANT"),
						type: "external",
						currencies: [],
						component: Vpag,
						languages: languages,
						externalFunc: {
							method: x.replace("Vpag", "").toLowerCase(),
							makeDeposit: props.depositVpag,
							getFilteredBonuses: getFilteredDepositBonuses,
						},
					};
				})
			)
			//TODO: mv monetix thailand to here
			.concat(
				[
					{
						id: "MonetixPromptpay",
						name: "deposit.monetix.promptpay",
						method: "Promptpay",
					},
					{
						id: "MonetixThailandBank",
						name: "deposit.monetix.thailand.bank",
						method: "ThailandBank",
					},
					{
						id: "MonetixRussiaP2PTransfer",
						name: "deposit.monetix.RussiaP2PTransfer",
						method: "RussiaP2PTransfer",
					},

					{
						id: "MonetixRussiaP2PTransferByCard",
						name: "deposit.monetix.RussiaP2PTransferByCard",
						method: "RussiaP2PTransferByCard",
					},
					{
						id: "MonetixRussiaP2PTransferByPhone",
						name: "deposit.monetix.RussiaP2PTransferByPhone",
						method: "RussiaP2PTransferByPhone",
					},
					{
						id: "MonetixRussiaP2PTransferBySber",
						name: "deposit.monetix.RussiaP2PTransferBySber",
						method: "RussiaP2PTransferBySber",
					},
					{
						id: "MonetixRussiaP2PTransferByTbank",
						name: "deposit.monetix.RussiaP2PTransferByTbank",
						method: "RussiaP2PTransferByTbank",
					},
					{
						id: "MonetixRussiaP2PTransferByAbroadPhone",
						name: "deposit.monetix.RussiaP2PTransferByAbroadPhone",
						method: "RussiaP2PTransferByAbroadPhone",
					},
					{
						id: "MonetixRussiaP2PTransferByAbroadCard",
						name: "deposit.monetix.RussiaP2PTransferByAbroadCard",
						method: "RussiaP2PTransferByAbroadCard",
					},
					{ id: "MonetixTrueMoneyWallet", name: "deposit.monetix.true.money.wallet" },
				].map((x) => {
					return {
						logo: paymentLogos[x.id],
						name: translate(x.name).toUpperCase(),
						id: x.id,
						bonusList: [],
						bonusId: "",
						convertionRates,
						userCurrency,
						bonusDescription: "",
						feature: translate("FREE_INSTANT"),
						type: "external",
						currencies: [],
						logoCls: x !== "MonetixPromptpay" ? "no-filter w-60" : "",
						component: Monetix,
						languages: languages,
						externalFunc: {
							method: x.method,
							makeDeposit: props.depositMonetix,
							getFilteredBonuses: getFilteredDepositBonuses,
						},
					};
				})
			)
			.concat(
				[
					"UnlimitBankCard",
					"UnlimitBancomer",
					"UnlimitPayPal",
					"UnlimitBoleto",
					"UnlimitOXXO",
					"UnlimitSPEI",
					"UnlimitPIX",
					"UnlimitQRCodePicPay",
					"UnlimitCodi",
					"UnlimitSoriana",
					"UnlimitWalmart",
					"UnlimitBodegaAurrera",
					"UnlimitSamsClub",
					"UnlimitCalimax",
					"UnlimitTiendasExtra",
					"UnlimitCirculoK",
					"Unlimit7Eleven",
					"UnlimitTelecomm",
					"UnlimitBanorte",
					"UnlimitFarmaciasBenavides",
					"UnlimitFarmaciasDelAhorro",
					"UnlimitWaldos",
					"UnlimitKiosko",
					"UnlimitFarmaciasSantaMaria",
					"UnlimitFarmaciasRoma",
					"UnlimitMerza",
					"UnlimitPayCash",
					"UnlimitPaynet",
				].map((x) => {
					const name = x.replace("Unlimit", "Unlimit ");
					return {
						logo: paymentLogos[x],
						name: name.toUpperCase(),
						id: x,
						bonusList: [],
						bonusId: "",
						bonusDescription: "",
						convertionRates,
						feature: translate("FREE_INSTANT"),
						type: "external",
						currencies: [],
						logoCls: x === "UnlimitOXXO" ? "no-filter" : "",
						component: Unlimit,
						languages: languages,
						externalFunc: {
							method: x.replace("Unlimit", ""),
							makeDeposit: props.depositUnlimit,
							getFilteredBonuses: getFilteredDepositBonuses,
						},
					};
				})
			)
			.concat(
				[
					{
						name: "Nuvei Credit Card",
						id: "NuveiCreditCard",
						method: "CreditCard",
					},
					{
						name: "Nuvei STP",
						id: "NuveiSTP",
						method: "STP",
					},
					{
						name: "Nuvei Pay Cash",
						id: "NuveiPayCash",
						method: "PayCash",
					},
					{
						name: "Nuvei Spei",
						id: "NuveiSpei",
						method: "Spei",
					},
				].map((x) => {
					return {
						logo: paymentLogos[x.id],
						name: x.name.toUpperCase(),
						id: x.id,
						bonusList: [],
						bonusId: "",
						convertionRates,
						userCurrency,
						bonusDescription: "",
						feature: translate("FREE_INSTANT"),
						type: "external",
						currencies: [],
						logoCls: "no-filter",
						component: Nuvei,
						languages: languages,
						externalFunc: {
							method: x.method,
							makeDeposit: props.depositNuvei,
							getFilteredBonuses: getFilteredDepositBonuses,
						},
					};
				})
			)
			.concat(
				[
					{ method: "AKISI", currencies: ["GTQ"] },
					{ method: "SOYFRI", currencies: ["GTQ"] },
					{ method: "TIGO_MONEY", currencies: ["USD"] },
					{ method: "GuatemalaCard", currencies: [] },
				].map(({ method, currencies }) => {
					return {
						logo: paymentLogos["ipay88"],
						name: method,
						id: "88Pay" + method,
						bonusList: [],
						bonusId: "",
						convertionRates,
						userCurrency,
						bonusDescription: "",
						feature: translate("FREE_INSTANT"),
						type: "external",
						currencies: currencies,
						logoCls: "no-filter",
						component: UnifyPay,
						languages: languages,
						externalFunc: {
							method: method,
							makeDeposit: props.deposit88pay,
							getFilteredBonuses: getFilteredDepositBonuses,
						},
					};
				})
			)
	);
}
